// extracted by mini-css-extract-plugin
export default {"cookies":"cookies_form_cookies__5Z24n","link":"cookies_form_link__VkKVS","buttonsContainer":"cookies_form_buttonsContainer__mHP7C","buttonYes":"cookies_form_buttonYes__G8X9c"};